<div class="modal-header">
  <h1 class="modal-title">{{ helpdeskInfo.title }}</h1>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.close()"
  ></button>
</div>
<div class="modal-body">
  <div class="container">
    @for (info of helpdeskInfo.infos | keyvalue; track info) {
      <div
        class="col-4 mt-3 d-inline-block"
        id="{{ info.key | kebabCase }}"
        >
        <h3>{{ info.key }}</h3>
        <div>{{ info.value }}</div>
      </div>
    }
    <div class="col-6 mt-3" id="jsession-id">
      <h3>Jsession ID</h3>
      <div>{{ helpdeskInfo.jsessionId }}</div>
    </div>
    <div class="col-6 mt-3" id="version">
      <h3>Version</h3>
      <div>{{ helpdeskInfo.version }}</div>
    </div>
  </div>
</div>
